import _ from 'underscore';
import popColumns from './projection/period-over-period-columns';
import { biSubColPrefix, popHeader } from './projection/period-over-period-header';

export const periodOverPeriodPlugin = definePlugin => definePlugin('popColumns', [
  'config',
  'gridView',
  'dateFilter',
], (
  config,
  gridView,
  dateFilter
) => {
  const pluginConfig = _.result(config.plugins, 'popColumns', {});
  const { i18n } = pluginConfig;

  const sortableHeaderCur = gridView.get('sortableHeader') || {};

  if (sortableHeaderCur.name && sortableHeaderCur.name.indexOf(biSubColPrefix) === 0) {
    const sortableHeader = _.defaults({
      name: sortableHeaderCur.name.slice(biSubColPrefix.length),
    }, sortableHeaderCur);
    gridView.set({ sortableHeader });
  }

  gridView.set({
    popHeader: {
      i18n,
    },
  });

  dateFilter.p$getCurrentDateRange().then((dateRange) => {
    gridView.set({
      popColumns: {
        expandedCols: [],
        dateRange,
        i18n,
      },
    });

    gridView.pipeStructureProjections(popColumns);
    gridView.pipeContentProjections(popHeader);
  });

  dateFilter.events.on('dateChange', () => {
    gridView.once('didReload', () => {
      const popColumnsConfig = gridView.get('popColumns');

      gridView.set({
        popColumns: _.defaults({
          dateRange: dateFilter.getCurrentDateRange(),
        }, popColumnsConfig),
      });
    });
  });
});
